/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/common';
import * as import4 from '../../../app/server/server-devices.component';
import * as import5 from '../../../app/services/api.service';
import * as import6 from '../../../app/services/local-storage.service';
import * as import7 from 'angular2-notifications/src/notifications.service';
import * as import8 from '../../../app/services/response.service';
import * as import9 from '@angular/router';
const styles_ServerDevicesComponent:any[] = ([] as any[]);
export const RenderType_ServerDevicesComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ServerDevicesComponent,
  data: {}
}
);
function View_ServerDevicesComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie danych serwera'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ServerDevicesComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'empty-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/gears.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak części do wyświetlenie - serwer w przygotowywaniu'])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDevicesComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks padded-heavy'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'class',
        'section-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      ' ( ',
      ' ) \n            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.type;
    ck(v,5,0,currVal_0);
    const currVal_1:any = v.context.$implicit.model;
    const currVal_2:any = v.context.$implicit.sn;
    ck(v,9,0,currVal_1,currVal_2);
  });
}
function View_ServerDevicesComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        'deviceList',
        1
      ]
      ],(null as any),4,'div',[[
        'class',
        'details-wrapper dashed lower'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDevicesComponent_5)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.serverElement.items;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_ServerDevicesComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'header',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Sprzęt:'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    \n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDevicesComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
    ,{
      ngIf: [
        0,
        'ngIf'
      ]
      ,
      ngIfElse: [
        1,
        'ngIfElse'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n    \n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDevicesComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.serverElement.type === 'no_physical_product');
    const currVal_1:any = co.deviceList;
    ck(v,12,0,currVal_0,currVal_1);
    const currVal_2:any = (co.serverElement.type !== 'no_physical_product');
    ck(v,15,0,currVal_2);
  },(null as any));
}
export function View_ServerDevicesComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDevicesComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDevicesComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import4.ServerDevicesComponent = v.component;
    const currVal_0:any = co.loadingServerData;
    ck(v,1,0,currVal_0);
    const currVal_1:boolean = !co.loadingServerData;
    ck(v,4,0,currVal_1);
  },(null as any));
}
function View_ServerDevicesComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-server-devices',([] as any[]),(null as any),(null as any),(null as any),View_ServerDevicesComponent_0,RenderType_ServerDevicesComponent)),
    import0.ɵdid(114688,(null as any),0,import4.ServerDevicesComponent,[
      import5.ApiService,
      import6.LocalStorageService,
      import7.NotificationsService,
      import8.ResponseService,
      import9.ActivatedRoute
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServerDevicesComponentNgFactory:import0.ComponentFactory<import4.ServerDevicesComponent> = import0.ɵccf('app-server-devices',import4.ServerDevicesComponent,View_ServerDevicesComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/server/server-devices.component.ngfactory.ts